exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".modal{z-index:1051!important}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/expiration-modal/expiration-modal.component.css"],"names":[],"mappings":"AAAA,OAME,sBAAyB,CAC1B","file":"expiration-modal.component.css","sourcesContent":[".modal {\n  /*\n   * Override z-index to 1051 for the expiration modal since\n   * the pattern-pack \"modal\" class has a z-index value of 1050\n   *\n   */\n  z-index: 1051 !important;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/expiration-modal/expiration-modal.component.css
// module id = 89tT
// module chunks = 0